import { Link } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';

function InstructorProfileSection({ instructor }) {
  return (
    <section className="overflow-hidden rounded-2xl bg-gradient-to-r from-[#0076C0] to-[#002B80] max-h-[258px] h-[258px]">
      <div className="flex flex-col gap-6 p-6 sm:flex-row sm:items-start sm:p-8">
        <div className="relative shrink-0">
          <div className="flex h-28 w-28 items-center justify-center rounded-full bg-[#69991D] p-1 sm:h-[195px] sm:w-[135px]">
            <img
              src={instructor.profileImage}
              alt={instructor.name}
              className="h-full w-full rounded-full object-cover"
            />
          </div>
        </div>

        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div className="p-2">
              <h2 className="text-xl font-semibold text-white sm:text-[20px]">{instructor.name}</h2>
              <p className="mt-1 text-[14px] font-medium tracking-wide text-[#CCCCCC]">{instructor.title}</p>
            </div>
            {instructor.id ? (
              <Link
                to={ROUTES.TEACHER_DETAIL(instructor.id)}
                className="rounded-lg border border-white/10 bg-[#1A87CC] px-4 py-2 text-sm font-semibold text-white transition hover:opacity-90"
              >
                View Profile
              </Link>
            ) : (
              <button
                type="button"
                className="rounded-lg border border-white/10 bg-[#1A87CC] px-4 py-2 text-sm font-semibold text-white transition"
              >
                View Profile
              </button>
            )}
          </div>

          <div className="mt-3 flex flex-wrap gap-6 p-2">
            <InstructorStat
              icon={
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" d="M12 14l9-5-9-5-9 5 9 5z" />
                  <path strokeLinecap="round" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
                </svg>
              }
              label={instructor.degree}
            />
            <InstructorStat
              icon={
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              }
              label={instructor.experience}
            />
            <InstructorStat
              icon={
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              }
              label={instructor.videos}
            />
          </div>

          <p className="mt-2 text-[14px] p-2 leading-relaxed text-[#CCCCCC]">{instructor.bio}</p>
        </div>
      </div>
    </section>
  );
}

function InstructorStat({ icon, label }) {
  return (
    <div className="flex items-center gap-2 text-white">
      {icon}
      <span className="text-sm font-medium">{label}</span>
    </div>
  );
}

export default InstructorProfileSection;
